import { useTranslation } from "react-i18next";
import { Map, FileCheck, Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

interface OrderProductSelectProps {
  onSelect: (product: "atlas" | "valid" | "adresstwatt") => void;
}

export function OrderProductSelect({ onSelect }: OrderProductSelectProps) {
  const { t } = useTranslation();

  const products = [
    {
      id: "atlas" as const,
      icon: Map,
      titleKey: "products.atlas.title",
      descKey: "products.atlas.description",
    },
    {
      id: "valid" as const,
      icon: FileCheck,
      titleKey: "products.valid.title",
      descKey: "products.valid.description",
    },
    {
      id: "adresstwatt" as const,
      icon: Sparkles,
      titleKey: "products.adresstwatt.title",
      descKey: "products.adresstwatt.description",
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold text-foreground">
          {t("order.selectProduct")}
        </h2>
        <p className="text-muted-foreground mt-1">
          {t("order.selectProductDesc")}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {products.map((product) => (
          <button
            key={product.id}
            onClick={() => onSelect(product.id)}
            className={cn(
              "group relative flex flex-col items-start p-8 rounded-xl border-2 border-border bg-card text-left transition-all duration-200",
              "hover:border-primary hover:shadow-lg hover:shadow-primary/5"
            )}
          >
            <div className="flex items-center gap-3 mb-4">
              <div className="p-3 rounded-lg bg-primary/10 text-primary">
                <product.icon className="h-6 w-6" />
              </div>
              <h3 className="text-xl font-semibold text-foreground">
                {t(product.titleKey)}
              </h3>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {t(product.descKey)}
            </p>
            <div className="mt-6 text-sm font-medium text-primary opacity-0 group-hover:opacity-100 transition-opacity">
              {t("order.chooseThis")} →
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
